import { FontIcon, ITooltipHostStyles, Stack, TooltipHost, TooltipOverflowMode, css, mergeStyleSets } from '@fluentui/react';
import { SharedColors } from '@fluentui/theme';
import * as React from 'react';
import { strings } from '../../../../../../../localization/strings';
import { IInspectionConfig, IInspectionConfigUI } from '@piceasoft/core';

type TStateProps = {
    config: IInspectionConfig<IInspectionConfigUI>
    icon?: string
}

export const SoftwareState: React.FC<TStateProps> = (props) => {
    return (
        <Stack tokens={{ childrenGap: 24 }}>
            <Stack.Item style={{ color: SharedColors.gray40 }}>
                <TooltipHost
                    overflowMode={TooltipOverflowMode.Self}
                    content={props.config.ui?.description ?? strings.CONSTRUCTOR.INSPECTIONS.SOFTWARE.CHECK_LOCKS_AND_ACCOUNTS}
                    styles={tooltipStyles}
                    hostClassName={css(styles.title)}
                >
                    {props.config.ui?.description ?? strings.CONSTRUCTOR.INSPECTIONS.SOFTWARE.CHECK_LOCKS_AND_ACCOUNTS}
                </TooltipHost>
            </Stack.Item>
            <Stack.Item>
                <Stack>
                    <Stack horizontalAlign="center">
                        <FontIcon iconName={props.icon ?? "BlockedSite"} style={{ fontSize: 128, height: 128, width: 128, color: SharedColors.gray20 }} />
                    </Stack>
                </Stack>
            </Stack.Item>
        </Stack>
    )
}

const styles = mergeStyleSets({
    title: [
        {
            overflow: 'hidden',
            overflowWrap: "break-word",
            maxHeight: 60,
        }
    ]
}) 

const tooltipStyles: Partial<ITooltipHostStyles> = {
    root: { display: 'block' }
}